import { IAdminTab } from "../@types/AdminRoute";
import { hasPermission } from "../utils/hasPermission";

/**
 * Top-tab navigation for the /reports section (EN-5129 — formerly /admin).
 * The reports dashboard moved here so /admin could be repurposed as the
 * SuperAdmin-only Retool replacement portal. Audit Logs lived here briefly
 * and now belongs to the /admin section only (see admin.routes.tsx).
 */
export const reportsTabs: IAdminTab[] = [
  {
    id: "home",
    name: "Home",
    labelKey: "reports_tabs_home",
    path: "/reports",
    matchPrefixes: ["/reports"],
    items: [],
  },
];

/**
 * Returns the reports tabs the current user is allowed to see — strips any
 * entry whose `requiredPermission` they don't hold. EN-4961.
 */
export function getVisibleReportsTabs(): IAdminTab[] {
  return reportsTabs.filter(
    (tab) => !tab.requiredPermission || hasPermission(tab.requiredPermission)
  );
}

/**
 * Resolves the active reports tab from the current pathname using
 * longest-prefix match, so a deeper tab wins over Home (prefix /reports)
 * if more tabs are added again.
 */
export function findActiveReportsTab(pathname: string): IAdminTab {
  const [fallback] = reportsTabs;
  let best = fallback;
  let bestLength = -1;

  reportsTabs.forEach((tab) => {
    tab.matchPrefixes.forEach((prefix) => {
      const matches = pathname === prefix || pathname.startsWith(`${prefix}/`);
      if (matches && prefix.length > bestLength) {
        best = tab;
        bestLength = prefix.length;
      }
    });
  });

  return best;
}
